import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { withRouter } from "react-router";
import { actions } from "../../actions";
import {
  getReturnDate,
  getDepartureDate,
} from "../../../search/reducer/selectors";
import {
  getPackageLodgingRoomInfoProducts,
  getHotelShopCallState,
  getPackageSelectedLodging,
  getHotelShopChosenProduct,
  getHotelShopChosenRoomInfoIndex,
  getHotelShopChosenProductIndex,
  getHotelShopChosenRoomInfo,
  hotelShopProgressSelector,
} from "../../reducer/selectors";
import { MobileHotelShopRoomTypePickerPanel } from "./component";
import { PackageHotelShopCallState } from "../../reducer/state";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../rewards/reducer";
import { getPackageNightCountBasedOnAvailability } from "../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => {
  const checkinDate = getDepartureDate(state);
  const checkoutDate = getReturnDate(state);
  const chosenRoomInfoIndex = getHotelShopChosenRoomInfoIndex(state);
  const chosenProductIndex = getHotelShopChosenProductIndex(state);
  const chosenRoomInfo = getHotelShopChosenRoomInfo(state);
  const chosenProduct = getHotelShopChosenProduct(state);
  const selectedLodging = getPackageSelectedLodging(state);
  const nightCount = getPackageNightCountBasedOnAvailability(state);
  const rewardsKey =
    getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined;
  const roomInfoProducts = getPackageLodgingRoomInfoProducts(state);
  const isHotelShopLoading =
    getHotelShopCallState(state) === PackageHotelShopCallState.InProcess;
  const hotelShopStep = hotelShopProgressSelector(state);

  return {
    checkinDate,
    checkoutDate,
    chosenRoomInfoIndex,
    chosenProductIndex,
    chosenRoomInfo,
    chosenProduct,
    selectedLodging,
    nightCount,
    rewardsKey,
    roomInfoProducts,
    isHotelShopLoading,
    hotelShopStep,
  };
};

const mapDispatchToProps = {
  selectRoomType: actions.selectRoomType,
  // fetchHotelShop: actions.fetchHotelShop,
  setPackageHotelShopProgress: actions.setPackageHotelShopProgress,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelShopRoomTypePickerPanelConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelShopRoomTypePickerPanel = withRouter(
  connector(MobileHotelShopRoomTypePickerPanel),
);
